import { filter } from "lodash-es";
import { Form } from "@king-design/vue";
import { isValidIPv4 } from "kdc-shared";
import { validInstanceName } from "./form-validation";
import { registerCheckDupStringFormRule } from "@kce2/common/core/hooks/use-check-dup-string";
import { verifyRoleLoose } from "../features/Cluster/utils/iam";
import { validateCron } from "../common/validator/cron";

// this method is not used so far, these rules come from kce1.0
export function registerLegacyKceFormMethods() {
  Form.addMethod(
    "2-64check",
    (value: string) => {
      // return /^[0-9a-zA-Z\u4e00-\u9fa5-,_.!@#$%^&*()?+/:;><=[\]`{}|~]{2,64}$/.test(value);
      return /^[0-9a-zA-Z\u4e00-\u9fa5-,.!$^*()%#&+/:;<=>[\]_`{|}~]{2,64}$/.test(value);
    },
    "2-64个字符，支持中文，英文，数字，以及特殊字符-,.!$^*()%#&+/:;<=>[]_`{|}~",
    // Vue.$trans("resource_name_check_rule"),
  );
  Form.addMethod(
    "8-32check",
    (value: string) => {
      return /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])([a-zA-Z0-9!"$%()*+,\-./:;<=>?@[\]^_`{|}~]{8,32})$/.test(
        value,
      );
    },
    "8-32个字符，必须包含大小写字母和数字，支持英文特殊字符!$%()*+,-./:;<=>?@[]^_`{|}~",
    // Vue.$trans("pwd_valid"),
  ); // '8-32个字符，必须包含大小写字母和数字，支持英文特殊字符!$%()*+,-./:;<=>?@[]^_`{|}~'
  Form.addMethod(
    "2-30check",
    (value: string) => {
      return /^[a-z0-9]([a-z0-9\-_]{0,28})[a-z0-9]$/.test(value);
    },
    '长度为2-30位，支持填写小写英文字母、数字，可使用分隔符包括"_"、"-"（分隔符不能在首位或末尾）',
    // Vue.$trans("2-30check_tip"),
  ); // 长度为2-30位，支持填写小写英文字母、数字，可使用分隔符包括"_"、"-"（分隔符不能在首位或末尾）
  Form.addMethod(
    "4-30check",
    (value: string) => {
      // return /^(?!_)(?!.*?_$)[a-z0-9_-]{4,30}$/.test(value);
      return /^[a-z0-9]{1}[a-z0-9\-_]{2,28}[a-z0-9]{1}$/.test(value) && !/[-_]{2}/.test(value);
    },
    '长度为4-30位，支持填写小写英文字母、数字，可使用的分隔符包括"_"、"-"（分隔符不能在首位或末尾）',
    // Vue.$trans("4-30check_tip"),
  ); // 长度为4-30位，支持填写小写英文字母、数字，可使用的分隔符包括"_"、"-"（分隔符不能在首位或末尾）
  Form.addMethod(
    "8-32checkLeast2",
    (value: string) => {
      return (
        !(
          /^[0-9]+$/.test(value) ||
          /^[a-zA-Z]+$/.test(value) ||
          /^[!$%()*+,\-./:;<=>?@[\]^_`{|}~]+$/.test(value)
        ) && /[0-9a-zA-Z!$%()*+,\-./:;<=>?@[\]^_`{|}~]{8,32}/.test(value)
      );
    },
    "8-32个字符，必须包含字母、数字和特殊字符中至少两项，支持英文特殊字符!$%()*+,-./:;<=>?@[]^_`{|}~",
    // Vue.$trans("password-validation-rule"),
  ); // '8-32个字符，必须包含字母、数字和特殊字符中至少两项，支持英文特殊字符!$%()*+,-./:;<=>?@[]^_`{|}~'
  Form.addMethod(
    "valueCheck",
    (value: string) => {
      return /(^[a-zA-Z0-9]{1}[a-zA-Z0-9\-_.]{0,61}[a-zA-Z0-9]{1}$)|(^[a-zA-Z0-9]{1}$)/g.test(
        value,
      );
    },
    '不超过63个字符，只能包含字母、数字及分隔符("-"、"_"、".")，且必须以字母、数字开头和结尾',
    // Vue.$trans("value_valid_rule"),
  ); // '不超过63个字符，只能包含字母、数字及分隔符("-"、"_"、".")，且必须以字母、数字开头和结尾'
  Form.addMethod(
    "keyCheck",
    (value: string) => {
      return /(^[a-zA-Z0-9]{1}[a-zA-Z0-9\-_./]{0,61}[a-zA-Z0-9]{1}$)|(^[a-zA-Z0-9]{1}$)/g.test(
        value,
      );
    },
    '不超过63个字符，只能包含字母、数字及分隔符("-"、"_"、"."、"/")，且必须以字母、数字开头和结尾',
    // Vue.$trans("key_valid_rule"),
  ); // '不超过63个字符，只能包含字母、数字及分隔符("-"、"_"、"."、"/")，且必须以字母、数字开头和结尾'
  Form.addMethod(
    "taintKeyCheck",
    (value: string) => {
      return /(^[a-zA-Z0-9]{1}[a-zA-Z0-9\-_./]{0,251}[a-zA-Z0-9]{1}$)|(^[a-zA-Z0-9]{1}$)/g.test(
        value,
      );
    },
    '不超过253个字符，只能包含字母、数字及分隔符("-"、"_"、"."、"/")，且必须以字母、数字开头和结尾',
    // Vue.$trans("taint_key_valid_rule"),
  ); // '不超过253个字符，只能包含字母、数字及分隔符("-"、"_"、"."、"/")，且必须以字母、数字开头和结尾'

  Form.addMethod(
    "63-check",
    (value: string) => {
      return /(^[a-z]{1}[a-z0-9-]{0,61}[a-z0-9]{1}$)|(^[a-z]{1}$)/g.test(value);
    },
    "不超过63个字符，只能包含小写字母、数字、和“-”，并且必须以小写字母开头，小写字母或数字结尾",
    // Vue.$trans(
    //   "bu_chao_guo_63_ge_zi_fu_zhi_neng_bao_han_xiao_xie_zi_mu_shu_zi_he_bing_qie_bi_xu_yi_xiao_xie_zi_mu_kai_tou_xiao_xie_zi_mu_huo_shu_zi_jie_wei",
    // ),
  );
  // 不超过63个字符，只能包含小写字母、数字、和“-”，并且必须以小写字母开头，小写字母或数字结尾

  Form.addMethod(
    "cm-key-check",
    (value: string) => {
      return /([-._a-zA-Z0-9]{1,63})/g.test(value);
    },
    '不超过63个字符，只能包含字母、数字及分隔符("-"、"_"、".")',
    // Vue.$trans("cm_key_check_tip"),
  ); // 不超过63个字符，只能包含字母、数字及分隔符("-"、"_"、".")

  Form.addMethod(
    "resource-name-check",
    (value: string) => {
      return /^[a-z0-9](([-a-z0-9]){0,61}[a-z0-9])?$/.test(value);
    },
    '不超过63个字符，只能包含小写字母、数字及分隔符("-")，且必须以小写字母、数字开头和结尾',
    // Vue.$trans("valume_check_name"),
  ); // 不超过63个字符，只能包含小写字母、数字及分隔符("-")，且必须以小写字母、数字开头和结尾

  Form.addMethod("check-net-number-3", function (value: string, param: { ipNumber: number }) {
    if (param.ipNumber && param.ipNumber < 3) {
      return "该子网可用IP数量小于3个，请更换子网";
      // return Vue.$trans(
      //   "gai_zi_wang_ke_yong_IP_shu_liang_xiao_yu_3_ge_，_qing_geng_huan_zi_wangN",
      // );
    }
    return true;
  });

  Form.addMethod(
    "textContent",
    (value: string) => {
      return /(^[a-z]{1}[a-z0-9-]{0,62}[a-z0-9]{1}$)|(^[a-z]{1}$)/g.test(value);
    },
    "不超过63个字符，只能包含小写字母、数字。并且必须以小写字母开头，小写字母或数字结尾",
    // Vue.$trans(
    //   "bu_chao_guo_63_ge_zi_fu_zhi_neng_bao_han_xiao_xie_zi_mu_shu_zi_he_bing_qie_bi_xu_yi_xiao_xie_zi_mu_kai_tou_xiao_xie_zi_mu_huo_shu_zi_jie_wei",
    // ),
  );

  // Form.addMethod(
  //   "sys-key-check",
  //   (value: string) => {
  //     return !store.state.create.SysLabels.includes(value);
  //   },
  //   Vue.$trans("sys_key_check_tip"),
  // );
}

export function valueCheck(value: string) {
  return /(^[a-zA-Z0-9]{1}[a-zA-Z0-9\-_.]{0,61}[a-zA-Z0-9]{1}$)|(^[a-zA-Z0-9]{1}$)/g.test(value)
    ? true
    : '不超过63个字符，只能包含字母、数字及分隔符("-"、"_"、".")，且必须以字母、数字开头和结尾';
}

/** EnvoyGateway 资源名称校验提示文案，与 envoy-name-check 规则同源，供表单输入框下方静态提示复用 */
export const ENVOY_NAME_RULE_TIP =
  '不超过63个字符，只能包含小写字母、数字及分隔符("-")，且必须以小写字母、数字开头和结尾，不能为纯数字';

export function registerFormMethods() {
  Form.addMethod(
    "kceClusterName",
    (v: string) => {
      const len = v.length;
      if (len < 2 || len > 64) {
        return "2-64个字符，支持中文，英文，数字，以及特殊字符-_";
      }

      const isTrue = /^[a-zA-Z\d\u4e00-\u9fa5\-_]{2,64}$/.test(v);
      return isTrue ? true : "2-64个字符，支持中文，英文，数字，以及特殊字符-_";
    },
    "",
  );
  Form.addMethod(
    "valueCheck",
    valueCheck,
    // Vue.$trans("value_valid_rule"),
  );
  Form.addMethod(
    "keyCheck",
    (value: string) => {
      return /(^[a-zA-Z0-9]{1}[a-zA-Z0-9\-_./]{0,61}[a-zA-Z0-9]{1}$)|(^[a-zA-Z0-9]{1}$)/g.test(
        value,
      );
    },
    '不超过63个字符，只能包含字母、数字及分隔符("-"、"_"、"."、"/")，且必须以字母、数字开头和结尾',
    // Vue.$trans("key_valid_rule"),
  );
  Form.addMethod(
    "taintKeyCheck",
    (value: string) => {
      return /(^[a-zA-Z0-9]{1}[a-zA-Z0-9\-_./]{0,251}[a-zA-Z0-9]{1}$)|(^[a-zA-Z0-9]{1}$)/g.test(
        value,
      );
    },
    '不超过253个字符，只能包含字母、数字及分隔符("-"、"_"、"."、"/")，且必须以字母、数字开头和结尾',
    // Vue.$trans("taint_key_valid_rule"),
  );

  Form.addMethod("instanceName", validInstanceName);

  // 整数（支持负数）
  Form.addMethod("integer", (value: any) => /^-?\d+$/.test(String(value)), "请输入有效整数");

  // 正整数
  Form.addMethod("positive-integer", function (value: string, param: { tip?: string }) {
    const tip = param.tip ? param.tip : "请输入正整数";
    return /^\d+$/.test(value) && +value > 0 ? true : tip;
  });

  const reIPv4LikeFormat = /^\d+\.\d+\.\d+\.\d+$/;
  // comes from OPENAPI source code
  const reSANDomain = /^([a-zA-Z0-9*-]+\.)*[a-zA-Z0-9*-]+\.[a-zA-Z]{2,}$/;

  Form.addMethod("san-rule", (v: string) => {
    if (reIPv4LikeFormat.test(v)) {
      return isValidIPv4(v) ? true : "无效 IPv4 地址";
    }
    return reSANDomain.test(v) ? true : "无效域名";
  });

  Form.addMethod("nodePoolNameRule", (v: string, params: boolean | { showMessage: boolean }) => {
    const showMessage = typeof params === "boolean" || params.showMessage === true;
    return /^[0-9a-zA-Z\u4e00-\u9fa5-,.!@$^*()%#&+/:;<=>[\]_`{|}~]{2,64}$/.test(v)
      ? true
      : showMessage
      ? "2-64个字符，支持中文，英文，数字，以及特殊字符-,.!@$^*()%#&+/:;<=>[]_`{|}~"
      : false;
  });

  Form.addMethod(
    "key-not-repeat",
    (
      value: string,
      param: {
        caseSensitive: boolean;
        field?: string | string[];
        selectList: any[];
        message?: string;
        item?: any; // item 为数组中的一个元素，当 field 为数组时，可能是希望比较多个 field 的值是否相同
      },
    ) => {
      const caseSensitive = param.caseSensitive;
      value = caseSensitive ? value.toLowerCase() : value;

      function getValue(field: string) {
        if (param.item) {
          const v = param.item[field];
          return caseSensitive ? v.toLowerCase() : v;
        }
        return value;
      }

      function isValueEqual(v: any, field: string) {
        const key = v[field];
        const val = getValue(field);
        if (caseSensitive) {
          return key.toLowerCase() === val;
        }
        return key === val;
      }

      if (
        filter(param.selectList, v => {
          if (Array.isArray(param.field)) {
            return param.field.every(f => isValueEqual(v, f));
          } else {
            return isValueEqual(v, param.field ?? "key");
          }
        }).length > 1
      ) {
        return param.message ?? "重复标签名";
      }
      return true;
    },
  );

  // 不超过n个字符，只能包含小写字母、数字、和“-”，并且必须以小写字母开头，小写字母或数字结尾
  Form.addMethod("n-check", function (value: string, param: any) {
    if (!param || typeof param !== "number") {
      // 默认63个字符
      param = 63;
    }

    const regex = new RegExp(`(^[a-z]{1}[a-z0-9-]{0,${param - 2}}[a-z0-9]{1}$)|(^[a-z]{1}$)`, "g");
    const result = regex.test(value);
    if (!result)
      return `不超过${param}个字符，只能包含小写字母、数字、和“-”，并且必须以小写字母开头，小写字母或数字结尾`;
    return true;
  });

  Form.addMethod(
    "envoy-name-check",
    (value: string) => {
      return /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/.test(value) && !/^\d+$/.test(value);
    },
    ENVOY_NAME_RULE_TIP,
  );

  registerCheckDupStringFormRule();
  Form.addMethod(
    "checkIamRole",
    async (
      v: string,
      { enable = true, region, roleName }: { enable?: boolean; region: string; roleName: string },
    ) => {
      if (!enable) {
        return true;
      }

      const isValid = await verifyRoleLoose(region, roleName);
      return isValid ? true : "未授权服务";
    },
  );

  Form.addMethod(
    "log-name-check",
    (value: string) => {
      return /(^[a-z0-9]{1}[a-z0-9\-_.]{0,38}[a-z0-9]{1}$)|(^[a-z0-9]{1}$)/g.test(value);
    },
    '不超过40个字符，只能包含小写字母、数字及分隔符("-"、"_"、".")，且必须以小写字母、数字开头和结尾',
  );

  Form.addMethod(
    "dup-string-check",
    (_v: string, params: { isNotRepeat: boolean }) => {
      return params.isNotRepeat;
    },
    "重复",
  );

  Form.addMethod("pwdChecker", pwdChecker);

  Form.addMethod(
    "event-center-name",
    (value: string) => {
      return /(^[a-z0-9]{1}[a-z0-9\-_.]{0,38}[a-z0-9]{1}$)|(^[a-z0-9]{1}$)/g.test(value);
    },
    '不超过40个字符，只能包含小写字母、数字及分隔符("-"、"_"、".")，且必须以小写字母、数字开头和结尾',
  );

  Form.addMethod("checkKcrAuth", function checkKcrAuth(_value, param: { isHasKcrAuth: boolean }) {
    return param.isHasKcrAuth || "您选择的镜像仓库企业版实例未开启P2P加速，请开通镜像仓库P2P加速";
  });

  Form.addMethod(
    "standard-cron", // 标准cron表达式，不支持秒级粒度
    (value: string) => {
      const vals = value.trim().split(" ");
      if (vals.length !== 5) {
        return "支持5个字段，分钟、小时、日、月份、星期，用空格分隔";
      }
      return validateCron("0 " + value);
    },
  );

  Form.addMethod("checkKcrAuth", function checkKcrAuth(_value, param: { isHasKcrAuth: boolean }) {
    return param.isHasKcrAuth || "您选择的镜像仓库企业版实例未开启P2P加速，请开通镜像仓库P2P加速";
  });

  Form.addMethod("valid-ks3-snapshot-name", (value: string) => {
    if (value.includes("/") || value.includes("@base@") || value.includes("@style@")) {
      return '快照名称不可包含"/"、"@base@"和"@style@"';
    }
    return true;
  });

  Form.addMethod("valid-ks3-dir-name", (value: string) => {
    const withoutSchema = value.split("//")?.[1];
    if (!withoutSchema) {
      return "请输入正确的ks3目录路径";
    }
    const toValid = withoutSchema.split("/").slice(1).join("/");
    if (toValid.includes("@base@") || toValid.includes("@style@")) {
      return 'ks3目录名称不可包含"@base@"和"@style@"';
    }
    return true;
  });

  // 通用 accept 规则：忽略表单值，仅依据 param.value 决定是否通过，message 由 :messages 提供。
  // 适用于需要根据外部响应式状态（如异步校验结果）控制校验通过与否的场景。
  Form.addMethod("accept", (_value: any, param: { value: boolean }) => param.value);
}

export function pwdChecker(v: string) {
  return /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])([a-zA-Z0-9!$%()*+,\-./:;<=>?@[\]^_`{|}~#]{8,32})$/.test(
    v,
  )
    ? true
    : "8-32个字符，必须包含大小写字母和数字，支持英文特殊字符!$%()*+,-./:;<=>?@[]^_`{|}~#";
}
